import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { Calendar, DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/teal.css";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import InputIcon from "react-multi-date-picker/components/input_icon";
import moment from "moment";

import SelectApplicants from "../../components/common/SelectApplicants/SelectApplicants";
import { AppContext } from "../../context/AppContext";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import CustomCalendar from "../../components/CustomCalender";
import useCompanyOptions from "../../components/common/CommonDeliverables/useCompanyOptions";
import useContractOptions from "../../components/common/CommonDeliverables/useContractOptions";
import ReactSelect from "react-select";
import LazyLoadedSelect from "../../components/LazyLoadedSelect/LazyLoadedSelect";
import { defaultSelectOption } from "../../helpers/utils";
import { checkModuleGeneralPermission } from "../../helpers/helpers";

const ApplicantListFilter = ({
  getPageType,
  personRegistryType,
  filterProfileCategory,
  filterNotVisiterFor,
  filterProfileStatus,
  filterContract,
  filterCompany,
  filterIdType,
  filterWithRegisterMode,
  filterWithAvatar,
  filterWithTestData,
  filterWithAccessPass,
  filterWorkPermitExpired,
  handleFilterProfileCategory,
  handleFilterNotVistedFor,
  handleFilterProfileStatus,
  handleFilterContract,
  handleFilterCompany,
  handleFilterIdType,
  handleFilterWorkPermitExpired,
  handleFilterWithRegisterMode,
  handleFilterWithAvatar,
  handleFilterWithTestData,
  handleFilterWithAccessPass,
  getNotVisitedOptions,
  getProfileStatusOptions,
  getIdTypeOptions,
  getWorkPermitExpiredOptions,
  getRegisterModeOptions,
  getAvatarOptions,
  getTestDataOptions,
  getAccessPassOptions,
}) => {
  const { userRoleDetails } = React.useContext(AppContext);

  const filterCompanyOptions = (currentOption) => {
    return !filterCompany?.find(
      (selectedCompany) => selectedCompany?.label === currentOption?.label
    );
  };

  const [showDatePicker, setShowDatePicekr] = useState(false);
  const [notVisiterFor, setNotVisiterFor] = useState(null);
  const [fromDate, setFromDate] = useState(
    moment().subtract(30, "days").format("DD-MM-YYYY")
  );
  const [toDate, setToDate] = useState(moment().format("DD-MM-YYYY"));
  const {
    companies,
    handleCompanySearch,
    loadNextCompanyOptionsPage,
    isCompanyLoading,
  } = useCompanyOptions();
  const {
    contracts,
    handleContractSearch,
    loadNextContractOptionsPage,
    isContractLoading,
  } = useContractOptions();

  const handleNotVistedSelection = (data) => {
    setNotVisiterFor(data);

    if (data.value === "custom") {
      return setShowDatePicekr(true);
    }
    handleFilterNotVistedFor(`preset|${data.value}`);
  };

  useEffect(() => {
    if (String(filterNotVisiterFor).length > 0) {
      let filterType = filterNotVisiterFor?.split("|")[0];
      if (filterType === "preset") {
        const notVisitedForOption = getNotVisitedOptions().find((option) => {
          return String(option?.value).includes(
            String(filterNotVisiterFor?.split("|")[1])
          );
        });
        setNotVisiterFor(notVisitedForOption ?? "");
      } else {
        let dateRange = filterNotVisiterFor?.split("|")[1];
        const [from, to] = dateRange.split(",");
        setFromDate(String(from));
        setToDate(String(to));
        const notVisitedForOption = getNotVisitedOptions().find((option) => {
          return String(option?.value).includes(
            String(filterNotVisiterFor?.split("|")[0])
          );
        });
        setNotVisiterFor(notVisitedForOption ?? "");
      }
    } else {
      setNotVisiterFor("");
      setFromDate(moment().subtract(30, "days").format("DD-MM-YYYY"));
      setToDate(moment().format("DD-MM-YYYY"));
    }
  }, [filterNotVisiterFor]);

  const customDateSumbit = () => {
    handleFilterNotVistedFor(`custom|${fromDate},${toDate}`);
    setShowDatePicekr(false);
  };

  return (
    <div className="advance-filter">
      {!getPageType() && (
        <div>
          <span>Category</span>
          <div className="mb-2">
            <SelectApplicants
              searchByApplicantType={(e) => handleFilterProfileCategory(e)}
              applicantType={filterProfileCategory}
            />
          </div>
        </div>
      )}
      <div>
        <span>Profile Status</span>
        <div className="mb-2">
          <Select
            isMulti
            className="cutomSelect"
            classNamePrefix="react-custom-select"
            value={filterProfileStatus}
            onChange={handleFilterProfileStatus}
            placeholder="Select"
            options={getProfileStatusOptions()}
          />
        </div>
      </div>
      <div>
        <span>Access Pass</span>
        <div className="mb-2">
          <Select
            className="cutomSelect"
            classNamePrefix="react-select"
            value={filterWithAccessPass}
            onChange={handleFilterWithAccessPass}
            options={getAccessPassOptions()}
            placeholder="Select"
          />
        </div>
      </div>
      <div>
        <span>Contracts</span>
        <div className="mb-2">
          <LazyLoadedSelect
            className="cutomSelect"
            classNamePrefix="react-custom-select"
            loadNextOptions={loadNextContractOptionsPage}
            name="contractors"
            onChange={handleFilterContract}
            onInputChange={(value) => handleContractSearch(value)}
            options={contracts}
            placeholder="Select"
            value={filterContract}
            isLoading={isContractLoading}
            defaultValue={defaultSelectOption()}
            hideSelectedOptions
            isMulti
          />
        </div>
      </div>
      <div>
        <span>Company</span>
        <div className="mb-2">
          <LazyLoadedSelect
            className="cutomSelect"
            classNamePrefix="react-custom-select"
            loadNextOptions={loadNextCompanyOptionsPage}
            name="company"
            onChange={handleFilterCompany}
            onInputChange={(value) => handleCompanySearch(value)}
            options={companies}
            placeholder="Select"
            value={filterCompany}
            isLoading={isCompanyLoading}
            filterOption={filterCompanyOptions}
            hideSelectedOptions
            isMulti
          />
        </div>
      </div>
      <div>
        <span>ID Type</span>
        <div className="mb-2">
          <Select
            className="cutomSelect"
            classNamePrefix="react-select"
            value={filterIdType}
            onChange={handleFilterIdType}
            options={getIdTypeOptions()}
            name="idType"
            placeholder="Select"
          />
        </div>
      </div>
      <div>
        <span>Work Permit Expired</span>
        <div className="mb-2">
          <Select
            className="cutomSelect"
            classNamePrefix="react-select"
            value={filterWorkPermitExpired}
            onChange={handleFilterWorkPermitExpired}
            options={getWorkPermitExpiredOptions()}
            name="workPermitExpired"
            placeholder="Select"
          />
        </div>
      </div>
      <div>
        <span>Register Mode</span>
        <div className=" mb-2">
          <Select
            className="cutomSelect"
            classNamePrefix="react-select"
            value={filterWithRegisterMode}
            onChange={handleFilterWithRegisterMode}
            options={getRegisterModeOptions()}
            placeholder="Select"
          />
        </div>
      </div>
      <div>
        <span>Not visited for</span>
        <div className="mb-2">
          <div>
            <Select
              className="cutomSelect"
              classNamePrefix="react-custom-select"
              value={notVisiterFor}
              placeholder="Select"
              onChange={handleNotVistedSelection}
              options={getNotVisitedOptions()}
            />
          </div>
        </div>
      </div>
      {personRegistryType !== "visitor-profile" && (
        <div>
          <span>Avatar</span>
          <div className=" mb-2">
            <Select
              className="cutomSelect"
              classNamePrefix="react-select"
              value={filterWithAvatar}
              onChange={handleFilterWithAvatar}
              options={getAvatarOptions()}
              placeholder="Select"
            />
          </div>
        </div>
      )}
      {checkModuleGeneralPermission(
        userRoleDetails,
        "person-registry",
        "view_test_data",
        {},
        true
      ) && (
        <div>
          <span>Test Data</span>
          <div className=" mb-2">
            <Select
              className="cutomSelect"
              classNamePrefix="react-select"
              value={filterWithTestData}
              onChange={handleFilterWithTestData}
              options={getTestDataOptions()}
              placeholder="Select"
            />
          </div>
        </div>
      )}

      <ModalComponent
        showSubmit={true}
        content={
          showDatePicker ? (
            <div>
              <div className="row">
                <div className="col-md-6">
                  <div className="">
                    <span> From</span>
                    <CustomCalendar
                      maxDate={
                        toDate
                          ? moment(toDate, "DD-MM-YYYY").toDate()
                          : moment().toDate()
                      }
                      dateFormat="DD-MM-YYYY"
                      onChange={(date) =>
                        setFromDate(moment(date).format("DD-MM-YYYY"))
                      }
                      selected={
                        fromDate === ""
                          ? ""
                          : moment(fromDate, "DD-MM-YYYY").toDate()
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="">
                    <span>To</span>
                    <CustomCalendar
                      maxDate={moment().toDate()}
                      onChange={(date) =>
                        setToDate(moment(date).format("DD-MM-YYYY"))
                      }
                      minDate={
                        fromDate ? moment(fromDate, "DD-MM-YYYY").toDate() : ""
                      }
                      dateFormat="DD-MM-YYYY"
                      selected={
                        toDate === ""
                          ? ""
                          : moment(toDate, "DD-MM-YYYY").toDate()
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null
        }
        header={"Select From and To Date"}
        show={showDatePicker}
        onSubmitCallback={customDateSumbit}
        onCloseCallback={() => setShowDatePicekr(false)}
        submitButtonText="Submit"
      />
    </div>
  );
};

export default ApplicantListFilter;
